import React, { useEffect, useMemo, useRef } from "react";
import "./WorkPrograms.css";

const WorkPrograms = () => {
  const workPrograms = useMemo(
    () => [
      {
        category: "Training Workshops and Seminars",
        details: [
          {
            title: "Applications Programming using Open-Source Languages",
            description:
              "Hands-on training to develop applications using open-source programming languages",
          },
          {
            title: "Using Analysis Tools in Applications",
            description:
              "Explore tools that enhance data analysis for real-world applications",
          },
          {
            title: "Recent Trends in Information Technologies",
            description:
              "Learn about the latest advancements and trends shaping technologies",
          },
        ],
      },
      
    ],
    []
  );

  const totalPrograms = useMemo(
    () => workPrograms.reduce((sum, p) => sum + p.details.length, 0),
    [workPrograms]
  );

  const sectionsRef = useRef([]);

  useEffect(() => {
    const els = sectionsRef.current.filter(Boolean);
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="work-homefit-page">
<section className="work-mini-hero work-mini-hero-fixed">
        <div className="work-mini-hero-inner">
          <div className="hero-left">
            <h1>Our Work Programs</h1>
            <p>
              Structured programs designed to build capabilities, recognize excellence, and deliver information value.
            </p>
          </div>

          <div className="hero-kpi" aria-label="Programs summary">
            <div className="hero-kpi-number">{totalPrograms}</div>
            <div className="hero-kpi-label">Programs</div>
          </div>
        </div>
      </section>

      <div className="work-sections">
        {workPrograms.map((program, index) => {
          const isDark = index % 2 === 0;
          return (
            <section
              key={program.category}
              ref={(el) => (sectionsRef.current[index] = el)}
              className={`work-band work-reveal ${isDark ? "dark" : "light"} ${isDark ? "reverse-layout" : ""}`}
            >
              <div className="band-inner">
  {/* Column 1: Title + short intro */}
  <div className="band-left">
    <h2 className="band-title">{program.category}</h2>
    <p className="band-subtitle">
      Explore the key initiatives and activities included in this work stream.
    </p>
  </div>

  {/* Column 2: Cards */}
  <div className="band-middle">
    <div className="program-grid">
      {program.details.map((d) => (
        <article key={d.title} className="program-card">
          <div className="program-card-title">{d.title}</div>
          <div className="program-card-desc">{d.description}</div>
        </article>
      ))}
    </div>
  </div>

  {/* Column 3: KPI */}
  <div className="band-right" aria-hidden="true">
    <div className="visual-card">
      <div className="visual-number">{program.details.length}</div>
      <div className="visual-label">ITEMS</div>
    </div>
  </div>
</div>

            </section>
          );
        })}
      </div>
    </div>
  );
};

export default WorkPrograms;
